<template>
  <div class="all">
    <div class="shz" v-if="path==1">企业认证审核中</div>
    <div class="wcrz_box" v-if="path==2">{{companyName}}</div>
    <div class="wcrz
    " v-if="path==2">
        <img src="../../../assets/member/gou.png" alt="">
        <span>已完成企业认证</span>
    </div>
    <div class="sqsb" v-if="path==3">
        <div>企业认证审核失败</div>
        <div>拒绝原因：信息不足</div>
        <div @click="apledsq">重新申请</div>
    </div>
  </div>
</template>

<script>
  import { useRouter, useRoute } from "vue-router"; //引入路由
 
import { ref,onMounted } from "vue";
export default {
    setup(){
         const router = useRouter()
         const route=useRoute()
         const companyName= ref('')
         const path=ref(0);
         const apledsq=()=>{
             router.push({
                 path:`/member/pointOrder/list2`, query: {jj:1 }
             })
         }
         onMounted(() => {
            path.value= route.query.applyStep;
            companyName.value= route.query.companyName;
            console.log(1111111)
         })
         return{

             path,
             apledsq,
             companyName
         }
    }
};
</script>

<style lang="scss" scoped>
@import "../../../style/orderwist.scss";
.wcrz_box{
     width:100%;
     height:100px;
     font-size:20px;
}
</style>
